/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface ExportIntegrationRequest {
    integrationId: string;
    versionId?: string;
    sign?: boolean;
    encrypt?: boolean;
    sessionId?: string;
}

export interface GetExportMetadataRequest {
    integrationId: string;
    versionId?: string;
    sessionId?: string;
}

/**
 * IntegrationExportApi - interface
 * 
 * @export
 * @interface IntegrationExportApiInterface
 */
export interface IntegrationExportApiInterface {
    /**
     * Exports an integration as a ZIP package containing scripts, mappings, schema, and metadata. Supports optional signing and encryption.
     * @summary Export integration as package
     * @param {string} integrationId Integration catalog ID
     * @param {string} [versionId] Optional version ID (uses latest if not provided)
     * @param {boolean} [sign] Sign the package for integrity verification
     * @param {boolean} [encrypt] Encrypt the package
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationExportApiInterface
     */
    exportIntegrationRaw(requestParameters: ExportIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Exports an integration as a ZIP package containing scripts, mappings, schema, and metadata. Supports optional signing and encryption.
     * Export integration as package
     */
    exportIntegration(requestParameters: ExportIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Returns metadata about what would be included in an export without creating the package
     * @summary Get export metadata
     * @param {string} integrationId Integration catalog ID
     * @param {string} [versionId] Optional version ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationExportApiInterface
     */
    getExportMetadataRaw(requestParameters: GetExportMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns metadata about what would be included in an export without creating the package
     * Get export metadata
     */
    getExportMetadata(requestParameters: GetExportMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationExportApi extends runtime.BaseAPI implements IntegrationExportApiInterface {

    /**
     * Exports an integration as a ZIP package containing scripts, mappings, schema, and metadata. Supports optional signing and encryption.
     * Export integration as package
     */
    async exportIntegrationRaw(requestParameters: ExportIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling exportIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['versionId'] != null) {
            queryParameters['versionId'] = requestParameters['versionId'];
        }

        if (requestParameters['sign'] != null) {
            queryParameters['sign'] = requestParameters['sign'];
        }

        if (requestParameters['encrypt'] != null) {
            queryParameters['encrypt'] = requestParameters['encrypt'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/export/{integrationId}`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Exports an integration as a ZIP package containing scripts, mappings, schema, and metadata. Supports optional signing and encryption.
     * Export integration as package
     */
    async exportIntegration(requestParameters: ExportIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.exportIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns metadata about what would be included in an export without creating the package
     * Get export metadata
     */
    async getExportMetadataRaw(requestParameters: GetExportMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getExportMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['versionId'] != null) {
            queryParameters['versionId'] = requestParameters['versionId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/export/{integrationId}/metadata`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns metadata about what would be included in an export without creating the package
     * Get export metadata
     */
    async getExportMetadata(requestParameters: GetExportMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getExportMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
